import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '@core/constants/routes.constants';
import {
  isHomeSectionHash,
  normalizeHashId,
  scrollToHomeSectionWithRetry,
} from '@utils/scroll.utils';

const isHomePath = (pathname: string): boolean =>
  pathname === ROUTES.HOME || pathname === '/';

/**
 * Redirects /#apps and /#courses to the homepage when opened from another route.
 */
export const useHomeSectionHashRedirect = (): void => {
  const { pathname, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!hash || !isHomeSectionHash(hash) || isHomePath(pathname)) {
      return;
    }

    navigate({ pathname: ROUTES.HOME, hash: normalizeHashId(hash) }, { replace: true });
  }, [pathname, hash, navigate]);
};

/**
 * Scrolls to #apps or #courses sections on the homepage.
 */
export const useHomeSectionHashScroll = (): void => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash || !isHomeSectionHash(hash) || !isHomePath(pathname)) {
      return;
    }

    return scrollToHomeSectionWithRetry(normalizeHashId(hash));
  }, [pathname, hash]);
};
